import i18n from '@/lib/i18n'
export default {
  methods: {
    getFieldNameFromFieldGeoInfoKey(fieldItemKey) {
      const field = this.getFieldFromGeoInfoKey(fieldItemKey)
      if (field) {
        return field.name
      }
      return i18n.tt('customFieldNoName')
    },
    getFieldFromGeoInfoKey(fieldItemKey) {
      // FIXME fieldItemKeyで引っ張るのではなく、pkで引っ張るべき
      // さらにはサーバー側でField名をJOINして返すべき
      if (fieldItemKey) {
        for (let f of this.$store.getters.fields) {
          if (f.geoInfoKey === fieldItemKey) {
            return f
          }
        }
        return null
      }
    },
    getFieldFromId(id) {
      if (id) {
        for (let f of this.$store.getters.fields) {
          if (f.id === id) {
            return f
          }
        }
        return null
      }
    },
  },
}
